import { updateHash } from "./scripts";

initAccordions();

export function initAccordions() {
  jQuery(function ($) {
    // ACCORDIONS
    $(".accordion").on("click", function () {
      var $section = $(this).parent(".tab-content");
      var accordionTarget;

      if ($section.length > 0) {
        accordionTarget = $section
          .children('div[data-id="' + $(this).data("target") + '"]')
          .first();
      } else {
        accordionTarget = $('div[data-id="' + $(this).data("target") + '"]').first();
      }

      // The chevron (.dropdown-icon) turns over in CSS on .active; see
      // components/_accordion.scss.
      if ($(this).hasClass("active")) {
        $(this).removeClass("active").attr("aria-expanded", false);
        $(accordionTarget).slideUp("fast");
      } else {
        $(this).addClass("active").attr("aria-expanded", true);
        $(accordionTarget).slideDown("fast");
      }

      updateHash($(this).data("target"));

      return false;
    });

    // ACCORDIONS keyboard support
    $(".accordion").on("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        $(this).click();
      }
      if (e.key === "Tab" && e.shiftKey) {
        e.preventDefault();
        $(this).prevAll(".accordion").first().focus();
        if ($(this).prevAll(".accordion").length === 0) {
          $(this).parent().find("a, button").first().focus();
        }
      }
      // accordion in tab
      if ($(this).parent().hasClass("tab-content")) {
        if ($(this).nextAll(".accordion").length === 0 && e.key === "Tab" && !e.shiftKey) {
          e.preventDefault();
          $("main").next().find("a, button").first().focus();
        }
        if ($(this).prevAll(".accordion").length === 0 && e.key === "Tab" && e.shiftKey) {
          e.preventDefault();
          $(this).parent().siblings(".tab.active").focus();
        }
      }
    });
  });
}
